import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './azizi-loader.scss';
export function AziziLoader({ message = 'Loading...' }) {
    return (_jsxs("div", { className: "azizi-loader", role: "status", "aria-live": "polite", "aria-busy": "true", children: [_jsxs("div", { className: "azizi-loader__logo-wrap", children: [_jsx("span", { className: "azizi-loader__ring", "aria-hidden": true }), _jsx("img", { src: "/assets/bma-logo.png", alt: "Bank Millie Afghan Loading" })] }), _jsx("p", { children: message })] }));
}
